export const ARABIC_FIELD_CLASS = "arabic_field";

export const arabicInputProps = { dir: "rtl" as const };

export const withArabicFieldClass = (className?: string) =>
  className ? `${className} ${ARABIC_FIELD_CLASS}` : ARABIC_FIELD_CLASS;
